import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import Backdrop from "../../../../common/Backdrop"
import bem from "../../../../../bem"
import { Symbols } from "@tenforce/toolbox-fontmap"
import UserInfo from "./UserInfo"
import Actions from "./Actions"

import "./UserMenu.scss"

const b = bem.with("NewUI__userMenu")
const userMenuVisible = "NewUI__userMenuVisible"

interface State {
    isOpened: boolean
}

export default class UserMenu extends React.PureComponent<unknown, State> {
    toggleButton: React.RefObject<HTMLButtonElement>

    constructor(props = null) {
        super(props)
        this.state = {
            isOpened: false,
        }
        this.toggleButton = React.createRef()
    }

    render(): JSX.Element {
        const { isOpened } = this.state

        return (
            <>
                <Action
                    onClick={this.show}
                    id="showUserMenuButton"
                    ref={this.toggleButton}
                    actionType={ActionType.icon}
                    extraClasses="is-inverted"
                >
                    {Symbols.User}
                </Action>
                <Backdrop
                    onHide={this.hide}
                    show={isOpened}
                    className={`NewUI ${b("content")}`}
                >
                    <div>
                        <UserInfo />
                        <Actions />
                    </div>
                </Backdrop>
            </>
        )
    }

    hide = (): void => {
        const appContainer = document.getElementById(
            "app-container",
        ) as HTMLElement
        appContainer.classList.remove(userMenuVisible)
        this.setState({ isOpened: false })
    }

    show = (): void => {
        const appContainer = document.getElementById(
            "app-container",
        ) as HTMLElement
        appContainer.classList.add(userMenuVisible)
        this.setState({ isOpened: true })
    }
}
